import { ArrowLeftRight } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { convertWithRates } from '@/hooks/useCurrentRates'
import { formatCurrency } from '@/lib/currency'
import { useT } from '@/i18n/I18nProvider'

// Indicador ⇄ ao lado de valores que NÃO estão na moeda base. No hover, mostra
// a conversão para a moeda base e a taxa atual usada (ex.: 1 USD = 7,6278 GTQ).
export function ConversionIndicator({
  amount,
  currency,
  baseCurrency,
  rates,
  converted,
  rate,
}: {
  amount: number
  currency: string
  baseCurrency: string
  rates?: Map<string, number> | undefined
  /** Conversão JÁ calculada (ex.: amount_base congelado da transação). Tem
   *  prioridade sobre `rates` — assim a tela de transações mostra a taxa DA DATA,
   *  não a atual. */
  converted?: number | null
  /** Taxa usada (para a linha "1 X = …"). Omitida → não mostra a linha da taxa. */
  rate?: number | null
}) {
  const { t } = useT()
  if (currency === baseCurrency) return null
  if (Math.abs(amount) < 0.005) return null // valor zero: sem indicador (fica em branco)
  const conv = converted != null ? converted : convertWithRates(amount, currency, rates)
  if (conv == null) return null
  const usedRate = rate != null ? rate : (rates?.get(currency) ?? null)
  const rateStr =
    usedRate != null
      ? new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 4 }).format(usedRate)
      : null

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-amber-500 inline-flex cursor-help align-middle" aria-label={t('dlg.conv.ariaConverted')}>
          <ArrowLeftRight className="size-3.5" />
        </span>
      </TooltipTrigger>
      <TooltipContent>
        <div className="font-medium">{t('dlg.conv.convertedTo', { value: formatCurrency(conv, baseCurrency) })}</div>
        {rateStr && (
          <div className="opacity-80">
            {t('dlg.conv.rateLine', { currency, rate: rateStr, base: baseCurrency })}
          </div>
        )}
      </TooltipContent>
    </Tooltip>
  )
}
